module.exports = __webpack_public_path__ + "static/img/BlobServer.ea0e006.png";